import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";

export default function Tile(props) {
  const { nodes, materials } = useGLTF("./models/tile.glb");
  return (
    <group {...props} dispose={null}>
      <mesh geometry={nodes.Cube.geometry} position={[0, -0.05, 0]} scale={[2, 0.05, 2]}>
        <meshStandardMaterial color={props.tileColor || "white"} />
      </mesh>
    </group>
  );
}

useGLTF.preload("./models/tile.glb");
